import { jsx as _jsx } from "react/jsx-runtime";
import 'emoji-mart/css/emoji-mart.css';
import { colors } from '@getgo/chameleon-core';
import { EmojiHappyOutlinedIcon } from '@getgo/chameleon-icons/react';
import { IconButton, Popover } from '@getgo/chameleon-web/react';
import { Picker, store } from 'emoji-mart';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './EmojiPicker.module.scss';
store.setNamespace('cca-emoji');
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
const EmojiPicker = ({ color, disabled, onClick }) => {
    console.warn('EmojiPicker is deprecated, use @ucc-messaging/inbox-common-ui instead');
    const { t } = useTranslation();
    const emojiPickerRef = useRef(null);
    const emojiPickerButtonRef = useRef(null);
    const [open, setOpen] = useState(false);
    const translations = {
        search: t('Search'),
        clear: t('Clear'),
        notfound: t('No Emoji Found'),
        skintext: t('Choose your default skin tone'),
        categorieslabel: t('Emoji categories'),
    };
    const togglePicker = useCallback(() => {
        setOpen(!open);
    }, [open]);
    const handleEmojiSelected = (data) => {
        setOpen(false);
        emojiPickerButtonRef.current.click(); /* TODO remove this and add isOpen attribute to the popover instead once https://jira.ops.expertcity.com/browse/CHAMELEON-2004 is done */
        onClick('native' in data ? data.native : '');
    };
    useEffect(() => {
        const listener = (event) => {
            if (!emojiPickerRef.current || emojiPickerRef.current.contains(event.target)) {
                return;
            }
            setOpen(false);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [emojiPickerRef]);
    const popoverTrigger = (_jsx("div", { children: _jsx(IconButton, Object.assign({ "data-testid": "emoji-icon-button", onClick: togglePicker, disabled: disabled, ref: emojiPickerButtonRef }, { children: _jsx(EmojiHappyOutlinedIcon, { style: !disabled && color && { color } }, void 0) }), void 0) }, void 0));
    return (_jsx(Popover, Object.assign({ position: 'top-end', menu: true, trigger: popoverTrigger, width: 355 }, { children: _jsx("div", Object.assign({ ref: emojiPickerRef, className: styles.picker, "aria-expanded": open, "data-test": "picker-container" }, { children: _jsx(Picker, { "data-test": "picker", i18n: translations, title: t('Choose an emoji'), native: true, onSelect: handleEmojiSelected, emojiTooltip: false, color: colors.blue.b500, theme: "light" }, void 0) }), void 0) }), void 0));
};
export default EmojiPicker;
//# sourceMappingURL=EmojiPicker.js.map